export default __webpack_public_path__ + "static/media/fitness.007b1557.svg";